export default "__VITE_ASSET__e5009c75__"